import React, { Fragment } from "react";

import Footer from "../components/footer";

//Con ancho="amplio" el contenido usa todo el ancho y toma las reglas de
//.main-container (tarjetas con sombra y radio de 12px), como las páginas de
//municipio. Sin la prop se comporta como siempre: una columna angosta y
//centrada, que es lo que necesita el login.
const Page = (props) => {
  const amplio = props.ancho === "amplio";
  return (
    <Fragment>
      <a className="skip-link" href="#contenido">
        Saltar al contenido
      </a>
      <main
        id="contenido"
        className={amplio ? "container main-container" : "container"}
      >
        <div className="row">
          <div
            className={
              amplio ? "col-md-12" : "col-md-6 d-block mx-auto p-box"
            }
          >
            {props.children}
          </div>
        </div>
      </main>

      <Footer />
    </Fragment>
  );
};

export default Page;
